









































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { 発注未確定重複レコード型 } from '@/type/purchaseorder/item';
import { 発注重複表示区分 } from '@/type/purchaseorder/types';
import { 表示用日付 } from '@/type/purchaseorder/order-function';

@Component({
  filters: {
    表示用日付を取得(日付: string): string {
      return 表示用日付(日付);
    },
  },
})

export default class DuplicateWarningDialog extends Vue {
  @Prop({default: []})
  private duplicateItemList!: 発注未確定重複レコード型;

  @Prop({ default: ''})
  private displayMode!: string;

  private 表示メッセージを取得(): string {
      if (this.displayMode === 発注重複表示区分.発注未確定登録) {
        return '一部の商品について、今回の登録により既に登録済みの発注と合わせて以下の発注数になります。';
      } else {
        return '確定送信対象の一部の商品が重複しています。今回の確定送信により合計で以下の発注数になります。';
      }
  }

  private 確定() {
    this.$emit('confirm-duplicate-warning');

  }

  private 戻る() {
    this.$emit('cancel-duplicate-warning');
  }
}
